import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"pointer",style:({
        opacity: (_vm.isLoad)?0.5:1
      }),on:{"click":_vm.onChange}},[(!_vm.isOk)?_c(VIcon,{attrs:{"small":_vm.small,"color":_vm.color}},[_vm._v("mdi-account-off")]):_c(VIcon,{attrs:{"small":_vm.small,"color":_vm.color}},[_vm._v("mdi-account")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }